import React from "react";
import { useForm } from "../../../hooks/useForm";
import { useAdminUserContext } from "../../common/providers/AdminUserProvider";

export const useAuthContainer = () => {
  const { login, isLoading } = useAdminUserContext();

  const [form, onChange] = useForm({
    email: "",
    password: "",
  });

  const isSubmitDisabled = !form.email || !form.password || isLoading;

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (isSubmitDisabled) {
      return;
    }

    const { email, password } = form;

    login({
      variables: {
        email,
        password,
      },
    });
  };

  return {
    models: {
      email: form.email,
      password: form.password,
      isLoading,
      isSubmitDisabled,
    },
    operations: {
      onChange,
      onSubmit,
    },
  };
};
